/* eslint-disable no-console */

export class ServiceBase {
  constructor() {
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
  }

  getAuthHeaders(accessToken: string, entityId: string = '') {
    if (!this.headers.has('Authorization')) {
      this.headers.append('Authorization', `Bearer ${this.accessToken}`);
    }

    if (entityId !== '' && !this.headers.has('X-Entity-Id')) {
      this.headers.append('X-Entity-Id', entityId);
    }

    return this.headers;
  }

  handleApiErrors(response) {
    if (!response.ok) {
      console.log(err);
      throw Error(response.statusText);
    }
    return response;
  }

  handleNetworkError(error) {
    console.log(error);
  }
}



// WEBPACK FOOTER //
// ./src/core/services/serviceBase.js